import React, { useState, useEffect } from 'react'
import {
    Grid,
    Typography,
    CircularProgress,
    Button,
    InputAdornment,
    Slider,
} from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'

import { useTheme } from '@material-ui/styles'
import TextField from '@material-ui/core/TextField'

import MUIDataTable from 'mui-datatables'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'

// styles
import useStyles from './styles'

// components
import PageTitle from '../../components/PageTitle/PageTitle'
import Widget from '../../components/Widget/Widget'
import axios from 'axios'
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'

// Contracts
const LGF_Contract = '0x4eadbfe053dcecdf13e51dc5e429305be6a802d3'

// Create our number formatter.
var formatter = new Intl.NumberFormat()

// Create our number formatter.
var formatterUS = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})
const marks = [
    {
        value: 0,
        label: '0%',
    },

    {
        value: 5,
        label: '5%',
    },
    {
        value: 10,
        label: '10%',
    },
]

function valuetext(value) {
    return `${value}°C`
}

// here I set the them
const getMuiTheme = () =>
    createMuiTheme({
        overrides: {
            MuiTableHead: {
                root: {
                    backgroundColor: '#EE266D;',
                },
            },
        },
    })

export default function SimulatorPage({ totaSuply, lgfPrice, lgfPriceLoader }) {
    var classes = useStyles()
    var theme = useTheme()
    //  const [balance, setBalance] = useState(lgfBalance || 170000000)
    const [price, setPrice] = useState(lgfPrice || 0.0000064)
    const [amountInvested, setAmountInvested] = useState(1000)
    const [reflectionRate, setReflectionRate] = useState(5)
    const [deflationaryRate, setDeflationaryRate] = useState(1)

    const datatableData = []
    for (var i = 0; i < 30; i++) {
        if (i === 0) {
            const balanceIni = parseFloat(amountInvested / price).toFixed(0)
            datatableData.push([
                i + 1,
                totaSuply,
                balanceIni,
                parseFloat(price * balanceIni * 1).toFixed(0),
                parseFloat(balanceIni * (10000000 / totaSuply)).toFixed(0),
                parseFloat(balanceIni * (50000000 / totaSuply)).toFixed(0),
                parseFloat(balanceIni * (100000000 / totaSuply)).toFixed(0),
            ])
        } else {
            const newTotalSupp = parseFloat(
                datatableData[i - 1][1] * (1 - deflationaryRate / 100)
            ).toFixed(2)

            const newBalance = parseFloat(
                datatableData[i - 1][2] * (1 + reflectionRate / 100)
            ).toFixed(2)
            datatableData.push([
                i + 1,
                parseFloat(newTotalSupp),
                parseFloat(newBalance),
                parseFloat(price * newBalance).toFixed(0),
                parseFloat((newBalance * 10000000) / newTotalSupp).toFixed(0),
                parseFloat((newBalance * 50000000) / newTotalSupp).toFixed(0),
                parseFloat((newBalance * 100000000) / newTotalSupp).toFixed(0),
            ])
        }
    }

    const handlePriceChange = event => {
        const { value } = event.target
        setPrice(parseFloat(value))
    }

    const handleAmountInvestedChange = (event, newValue) => {
        const { value } = event.target
        setAmountInvested(parseFloat(value))
    }

    const handleReflectionChange = (event, newValue) => {
        if (typeof newValue === 'number') {
            setReflectionRate(parseFloat(newValue))
        }
    }
    const handleDeflationaryChange = (event, newValue) => {
        if (typeof newValue === 'number') {
            setDeflationaryRate(newValue)
        }
    }
    return (
        <>
            <Grid container>
                <PageTitle title="Calculator / Simulation" />

                <Grid item xs={12} md={12}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={3}>
                            <Widget
                                title="Amount Invested (USD)"
                                disableWidgetMenu
                            >
                                <div className={classes.dashedBorder}>
                                    <TextField
                                        id="component-helper7"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <AttachMoney />
                                                </InputAdornment>
                                            ),
                                        }}
                                        style={{ width: '100%' }}
                                        defaultValue={amountInvested}
                                        onChange={handleAmountInvestedChange}
                                    />
                                </div>
                            </Widget>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Widget title="$JPG Price" disableWidgetMenu>
                                <div className={classes.dashedBorder}>
                                    <TextField
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <AttachMoney />
                                                </InputAdornment>
                                            ),
                                        }}
                                        defaultValue={price}
                                        onChange={handlePriceChange}
                                    />
                                </div>
                            </Widget>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Widget
                                title="Reflection rate/day"
                                disableWidgetMenu
                            >
                                <div className={classes.dashedBorder}>
                                    <Slider
                                        aria-label="Reflection rate per day"
                                        defaultValue={5}
                                        step={0.1}
                                        valueLabelDisplay="auto"
                                        getAriaValueText={valuetext}
                                        marks={marks}
                                        min={0}
                                        max={10}
                                        onChange={handleReflectionChange}
                                    />
                                </div>
                            </Widget>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Widget
                                title="Deflationary rate/day"
                                disableWidgetMenu
                            >
                                <div className={classes.dashedBorder}>
                                    <Slider
                                        aria-label="Deflationary rate per day"
                                        defaultValue={1}
                                        step={0.1}
                                        valueLabelDisplay="auto"
                                        getAriaValueText={valuetext}
                                        marks={marks}
                                        min={0}
                                        max={10}
                                        onChange={handleDeflationaryChange}
                                    />
                                </div>
                            </Widget>
                        </Grid>
                        <Grid item xs={12}>
                            {/*   <MuiThemeProvider theme={getMuiTheme()}> */}
                            <MUIDataTable
                                title="Value @ various market cap"
                                data={datatableData}
                                columns={[
                                    {
                                        name: 'Day',
                                    },
                                    {
                                        name: 'Tota Supply',
                                    },
                                    {
                                        name: 'Balance $JPG',
                                    },
                                    {
                                        name: '@ Actual MC',
                                    },
                                    {
                                        name: '@ $10,000,000',
                                    },
                                    {
                                        name: '@ $50,000,000',
                                    },
                                    {
                                        name: '@ $100,000,000',
                                    },
                                ]}
                                options={{
                                    rowsPerPage: 30,
                                    filterType: 'checkbox',
                                    selectableRowsHeader: false,
                                    selectableRows: 'none',
                                    print: false,
                                    search: false,
                                    filter: false,

                                    textLabels: {
                                        body: {
                                            noMatch: lgfPriceLoader ? (
                                                <CircularProgress
                                                    size={26}
                                                    className={
                                                        classes.loginLoader
                                                    }
                                                />
                                            ) : (
                                                'Sorry, there is no data to display'
                                            ),
                                        },
                                    },
                                }}
                            />
                            {/*  </MuiThemeProvider> */}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}
